import React from 'react'
import logo from '../../img/intelli X Logo.png'
import { NavLink } from 'react-router-dom'

const Login = () => {
  return (
    <>

    <section>
     <div className='container' style={{paddingTop:'20px'}}>
      <div className='row'>
       <div className='col-lg-6 col-sm-12'>
  
         <img src={logo} alt='image' style={{width:'200px'}}/>
          
       </div>
       <div className='col-lg-3 col-sm-12'>
       </div>
       <div className='col-lg-3 col-sm-12 mt-3'> 
        <p style={{fontWeight:'500'}}>Not a Customer ?<NavLink to='' style={{textDecoration:'none'}}> Sign Up </NavLink></p>
          
       </div>
      </div>
     </div>



       <div className='container mt-5'>
        <div className='row'>
         <div className='col-lg-5 col-sm-12 m-auto'>

           <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12'>
             
            <div class="card" style={{boxShadow: '0px 4px 12px rgba(158, 158, 158, 0.25)', border:'none'}}> 
            <div class="card-body">
              <h5 class="card-title">Login</h5>
               

              <div className='mt-5'>
              <input type="text" class="form-control" placeholder="Enter Email/Contact Number" aria-label="Username" aria-describedby="basic-addon1" style={{border:'1px solid #ededed', padding:'10px 10px'}}/>

              </div>



              <div className='mt-4'>
              <input type="text" class="form-control" placeholder="Enter Password" aria-label="Username" aria-describedby="basic-addon1" style={{border:'1px solid #ededed', padding:'10px 10px'}}/>

              <p className='pt-2' style={{color:'#3572FA', float:'right'}}>Forgot Password ?</p>

              </div>
               
                 <div className='mt-5 pt-5'>
                 
                   <button type='btn' className='mb-4'  style={{backgroundColor:'#3572FA', width:'100%',
                    border:'none',padding:'13px 10px', borderRadius:'8px', color:'#fff' }}>Get Started</button>
                 </div>
 
            </div>
          </div> 
            </div>
           </div>
          
         </div>
        </div>
       </div>
     
    </section>
    
    
    </>
  )
}

export default Login